import { createForm } from '@ps/web-shared-ui';
import React, { useEffect, useState } from 'react';
import { FormSpy } from 'react-final-form';
import { useSelector } from 'react-redux';

import useSearchParams from '@swf/core/hooks/useSearchParams';
import { PKR_LOADERS, useHomeGamesWidget } from '@swf/poker';

import Loader from '../../Loader/Loader';
import Error from '../../Modal/Error/Error';
import useCreateClubTable from '../hooks/useCreateClubTable';
import type { FormValues } from '../utils/common';

import styles from './Container.scss';
import CreateGameForm from './CreateGameForm';

interface SearchParams {
  clubId?: string;
  widgetId?: string;
}

const Form = createForm<FormValues>();

const Container = () => {
  const [error, setError] = useState('');
  const { clubId, widgetId } = useSearchParams<SearchParams>();
  const { widgetDispatch, widgetSelect } = useHomeGamesWidget(widgetId);
  const { tableParams, initialValues } = useSelector(widgetSelect.tableStructures);
  const loadingState = useSelector(widgetSelect.loading);
  const loading = loadingState[PKR_LOADERS.tableStructures];

  useEffect(() => {
    widgetDispatch.fetchTableStructures({ clubId: Number(clubId) });
  }, [clubId, widgetDispatch]);

  const { handleSubmit, loading: submitting } = useCreateClubTable(tableParams, setError);

  return (
    // TODO: Use Skeleton loader
    <Loader className={styles.loader} loading={loading || !initialValues}>
      <Form className={styles.formContainer} onSubmit={handleSubmit} initialValues={initialValues}>
        <FormSpy
          subscription={{
            modified: true,
            values: true,
            submitSucceeded: true,
            submitError: true,
            submitFailed: true
          }}
          render={() => <CreateGameForm gameData={tableParams} loading={loading || submitting} />}
        />
        <Error onClose={() => setError('')} error={error} />
      </Form>
    </Loader>
  );
};

export default Container;
